// error code should start from 1001
module.exports = {
  1001: 'Language must not be Empty',
  1002: 'Theme %s:%s:%s not Set',
  1003: 'Theme %s not Found',
  1004: 'Cannot delete if has children',
  1005: 'Cannot delete if has articles',
  1006: 'Build Site First',
};
